module.exports = __webpack_public_path__ + "img/cafe_restaurant_lys.114cde58.jpg";